import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconPackage = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={16}
      fill="none"
      viewBox="0 0 15 16"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path d="M7.06226 6.7465L6.10352e-05 3.68683V12.5686L7.06226 15.6348V6.7465Z" fill="currentColor" />
      <path d="M14.4421 3.02166L7.47741 0L0.512756 3.02166L7.47741 5.96449L14.4421 3.02166Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9568 12.5686L7.89456 15.6348V6.7465L14.9568 3.68683V12.5686ZM11.6042 8.52137L8.94578 9.67559V7.44649L11.6042 6.29472V8.52137Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
